<h3>Agent Details</h3>
<nz-table nzBordered [nzShowPagination]="false" class="mt-2" [nzData]="[0]" [nzSize]="'small'">
	<thead>
		<tr>
			<th style="width: 200px;">Field</th>
			<th>Value</th>
		</tr>
	</thead>
	<tbody>
		<tr><td><strong>Username</strong></td><td>{{ agent.username }}</td></tr>
		<tr><td><strong>Email Address</strong></td><td>{{ agent.emailAddress }}</td></tr>
		<tr><td><strong>Phone Number</strong></td><td>{{ agent.msisdn }}</td></tr>
		<tr><td><strong>Name</strong></td><td>{{ agent.firstName }}</td></tr>
		<tr><td><strong>Surname</strong></td><td>{{ agent.lastName }}</td></tr>
	</tbody>
</nz-table>

<nz-descriptions [nzColumn]="{ xxl: 6, xl: 4, lg: 4, md: 3, sm: 2, xs: 1 }" nzLayout="vertical" nzBordered class="mt-2">
	<nz-descriptions-item *ngFor="let property of getDynamicProperties(agent.properties)" [nzTitle]="property">{{agent.properties[property]}}</nz-descriptions-item>
</nz-descriptions>
